/**
 * An interface to export/import JSON
 */
import { EntityDecoder } from './decoder'

/**
 * An entity interface
 */
export interface IEntity {
    fromJson(jsonObject: object, convertToCamel?: boolean): any
}

/**
 * An abstract entity class.  All concrete classes should extend this.
 */
export abstract class Entity implements IEntity {
    public fromJson(jsonObject: object, convertToCamel = false): any {
        return EntityDecoder.jsonDecode(this, jsonObject, convertToCamel)
    }
}
